// First, so demo mode (if built in) is in place before anything reads a session.
import { DEMO } from './demo'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, HashRouter } from 'react-router-dom'
import './index.css'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'

// The demo is one HTML file opened straight from disk, where only hash URLs work.
const Router = DEMO ? HashRouter : BrowserRouter

// Applied before first paint so the page doesn't flash the wrong theme.
try {
  document.documentElement.dataset.theme = localStorage.getItem('lereco-theme') || 'dark'
} catch {
  document.documentElement.dataset.theme = 'dark'
}

// These only log. An uncaught error outside React's render tree does not crash
// the tab — one fire-and-forget fetch without a .catch must not replace the
// whole screen with a fallback for something the user never noticed.
window.addEventListener('error', (e) => console.error('Uncaught error:', e.error || e.message))
window.addEventListener('unhandledrejection', (e) => console.error('Unhandled rejection:', e.reason))

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <Router>
        <App />
      </Router>
    </ErrorBoundary>
  </StrictMode>
)
